module.exports = __webpack_public_path__ + "static/img/m11.2697057.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/m11.jpg
// module id = FZx2
// module chunks = 1